import { useState } from "react";
import { faqs } from "@/mocks/faqs";
import SectionHeading from "@/components/base/SectionHeading";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100">
      <div className="w-full grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-24">
            <SectionHeading
              kicker="常见问题"
              title="关于追瓜，你可能想问"
              desc="从内容整理方式到投稿纠错，这里集中回答最常被问到的问题。"
            />
          </div>
        </div>

        <div className="lg:col-span-8">
          <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
            {faqs.map((item, idx) => {
              const isOpen = openIndex === idx;
              return (
                <div key={item.q}>
                  <h3>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? -1 : idx)}
                      aria-expanded={isOpen}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors duration-200 hover:bg-background-100 cursor-pointer"
                    >
                      <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                        {item.q}
                      </span>
                      <span
                        className={`w-7 h-7 shrink-0 flex items-center justify-center rounded-full text-sm transition-colors duration-200 ${
                          isOpen
                            ? "bg-primary-500 text-background-50"
                            : "bg-background-200 text-foreground-600"
                        }`}
                      >
                        <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                      </span>
                    </button>
                  </h3>
                  {isOpen && (
                    <div className="px-5 pb-5 -mt-1">
                      <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}